module.exports = __webpack_public_path__ + "static/media/table-avatar.87c338f5.svg";